import { render } from "./How.vue?vue&type=template&id=537a79b2&scoped=true"
import script from "./How.vue?vue&type=script&lang=js"
export * from "./How.vue?vue&type=script&lang=js"

import "./How.vue?vue&type=style&index=0&id=537a79b2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537a79b2"]])

export default __exports__